import React from 'react';
import BaseIcon from './BaseIcon';


const FolderIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 14C0.715086 14 0.458 13.8808 0.275857 13.6897C0.10493 13.5102 0 13.2674 0 13V5C0 4.44772 0.447715 4 1 4H2V3C2 2.44772 2.44772 2 3 2H8C8.55228 2 9 2.44772 9 3V4H13C13.5523 4 14 4.44772 14 5V6H7V4H4V6H2V11.6667L4 7H16L13 14H1ZM11.6812 12L12.9669 9H5.31879L4.03308 12H11.6812Z" fill="#0088CC" />
    </g>
  </BaseIcon>
);

export default FolderIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/FolderIcon.jsx